import { useUiStore } from '@/stores/ui.store.ts'
import { HTTPError } from 'ky'
import { translate } from '@/i18n/i18n.ts'
import { isPromiseRejectedResultArray } from '@/ts/guards/common.type-guards.ts'

export const useGlobalErrorService = () => {
  const uiStore = useUiStore()

  function handleError(error: unknown, enableLog: boolean = true) {
    if (error instanceof HTTPError) {
      handleApiError(error)
    }

    if (isPromiseRejectedResultArray(error)) {
      const rejectedResults = error
      rejectedResults.forEach((failure) => {
        handleError(failure.reason)
      })
    }

    if (enableLog) {
      console.error(error)
    }
  }

  /**
   * Currently just returning the default retry message from Figma Design.
   * We could add more explicit response code handling here.
   */
  function handleApiError(error: HTTPError) {
    switch (error.response.status) {
      default:
        uiStore.setError(translate('api_errors.retry'))
        break
    }
  }

  return {
    handleError
  }
}
